import { ConsultantChoosingConsultationContainer } from '../containers/ConsultantChoosingConsultationContainer/index'

export const ConsultantChoosingConsultationPage = () => (
    <ConsultantChoosingConsultationContainer />
)